/**
 * "Bekleyen dış etkili işler" (karantina incelemesi) ekranının metinleri (M6 WP 6.6). İş sınıfı, neden, durum ve karar
 * etiketleri paylaşılan `JOB_QUARANTINE_TEXT`'ten gelir (sunucuyla tek kaynak); burada yalnız ekrana özgü metinler durur.
 */
export const QUARANTINE_REASON_MIN = 5;
export const QUARANTINE_REASON_MAX = 1000;

export const quarantineText = {
  nav: 'Bekleyen dış etkili işler',
  title: 'Bekleyen dış etkili işler',
  description:
    'Karantinadaki iş otomatik çalışmaz. Her iş için çalışma alanı yöneticisi karar verir: serbest bırakır, iptal eder ya da teslim edildi olarak işaretler. Her karar kimin, ne zaman ve hangi gerekçeyle verdiği bilgisiyle kayda geçer.',
  readOnly: 'Bekleyen dış etkili işleri yalnız çalışma alanı yöneticileri inceleyebilir.',
  failed: 'İşlem tamamlanamadı',
  summaryFailed: 'Özet yüklenemedi',
  listFailed: 'Liste yüklenemedi',
  refresh: 'Yenile',
  cancel: 'Vazgeç',
  unknownUser: 'kullanıcı kaydı yok',
  /** Platform düzeyi dış etki beklemesi (M7 T3): yalnız işletim ekibi kaldırır; bu ekrandan kaldırılamaz */
  platformHold: {
    title: 'Platform düzeyinde dış etki beklemesi etkin',
    body: 'Bekleme sürerken e-posta, web kancası ve otomasyon işleri gönderilmez; bu listede bekler. Kayıt, arama ve rapor gibi iç işlemler etkilenmez. Beklemeyi yalnız işletim ekibi kaldırır; o zamana kadar işler serbest bırakılamaz. İptal ve "teslim edildi" kararları verilebilir.',
    reason: (why: string, since: string | null) =>
      since === null ? `Neden: ${why}` : `Neden: ${why} · Başlangıç: ${since}`,
    reasonUnknown: 'belirtilmedi',
  },
  /** G6 çalışma alanı düzeyi dış etki beklemesi: işletim ekibi verir ve kaldırır; yönetici yalnız görür */
  tenantHold: {
    title: 'Bu çalışma alanında dış etki beklemesi etkin',
    body: 'Aşağıdaki türlerdeki işler gönderilmez; kaydedilir ve bu listede bekler. Kayıt, arama, rapor ve diğer iç işlemler etkilenmez. Parola sıfırlama postası beklemeden etkilenmez. Beklemeyi yalnız işletim ekibi değiştirir; bekleyen türdeki işler bekleme sürerken serbest bırakılamaz. Bekleme kalkınca da kendiliğinden gönderilmez, her biri için ayrıca karar verilir.',
    categoriesTerm: 'Bekleyen türler',
    reasonTerm: 'Gerekçe',
    sinceTerm: 'Başlangıç',
    inviteNote:
      'Davet postası bu sürede yalnız yetkili kullanıcının ya da işletim ekibinin açıkça verdiği davetle gider.',
  },
  hold: {
    title: 'Geri yükleme sonrası dış etki beklemesi etkin',
    body: 'Bekleme sürerken arka planda oluşan yeni e-posta, web kancası ve otomasyon işleri kuyruğa girmez; bu listeye düşer. Kullanıcının o anda açıkça başlattığı işlemler etkilenmez.',
    release: 'Beklemeyi kaldır',
    dialogTitle: 'Dış etki beklemesi kaldırılsın mı?',
    dialogBody:
      'Bekleme kalkınca arka planda oluşan yeni dış etkili işler yeniden kuyruğa girer ve gönderilir. Bu listedeki işler kendiliğinden çalışmaz; her biri için ayrıca karar verilir.',
    openNote: (n: number) =>
      `Karara bağlanmamış ${String(n)} iş var; bekleme kalktıktan sonra da bu listede kalır.`,
    confirm:
      'Listeyi inceledim; yeni dış etkili işlerin yeniden gönderilmeye başlamasını onaylıyorum.',
    done: 'Dış etki beklemesi kaldırıldı',
  },
  lastRun: {
    title: 'Son geri yükleme',
    kindTerm: 'Tür',
    kind: { restore: 'Geri yükleme', rollback: 'Geri alma' } as const,
    source: 'Kaynak',
    backupAt: 'Yedek anı',
    restoredAt: 'Geri yükleme anı',
    quarantined: 'Karantinaya alınan işler',
    quarantinedNone: 'Yok',
    deliveredAfterBackup: 'Yedekten sonra teslim edilmiş ve yedekte bekliyor görünen iş',
    holdTerm: 'Dış etki beklemesi',
    holdActive: 'Etkin',
    holdReleased: (at: string, by: string, note: string | null) =>
      `Kaldırıldı: ${at} · ${by}${note === null ? '' : ` — ${note}`}`,
    lostTitle: 'Yedekten sonra gerçekleşmiş, geri yüklenen veride kaydı bulunmayan teslimler',
    lostBody:
      'Bu teslimler yedek anından sonra yapıldı ve geri yüklenen veride kayıtları yok. Liste yalnız bilgi içindir; buradan eylem yapılamaz.',
    lostEmpty: 'Böyle bir teslim saptanmadı.',
    lostPartial: (shown: number, total: number) =>
      `İlk ${String(shown)} / toplam ${String(total)} teslim gösteriliyor.`,
    colJob: 'İş türü',
    colDeliveredAt: 'Teslim anı',
    colRef: 'Sağlayıcı başvurusu',
  },
  filters: {
    jobClass: 'İş sınıfı',
    origin: 'Neden',
    all: 'Tümü',
  },
  list: {
    title: 'Karar bekleyen işler',
    total: (n: number) => `Toplam ${String(n)} iş karar bekliyor`,
    empty: 'Karara bağlanmamış iş yok.',
    emptyFiltered: 'Bu süzgece uyan, karara bağlanmamış iş yok.',
    more: 'Daha fazla göster',
    colJob: 'İş',
    colStatus: 'Durum',
    colWhy: 'Neden karantinada',
    colPrior: 'Önceki teslim kanıtı',
    colActions: 'Eylemler',
    updated: (at: string) => `Son güncelleme: ${at}`,
    noTarget: 'Hedef özeti yok',
    // v3.1 B3: askı ya da deneme sonu incelemesinde 72 saatten eski iş — varsayılan öneri iptal (serbest bırakılabilir)
    cancelSuggested: 'İptal önerilir',
    cancelSuggestedHint: 'Bu iş 72 saatten eski; alıcı için artık geçerli olmayabilir.',
    attempts: (n: number) => `${String(n)} deneme`,
    lastError: (text: string) => `Son deneme sonucu: ${text}`,
    priorNone: 'Kayıt yok',
    priorDelivered: (at: string | null, ref: string | null) =>
      `Geri yüklemeden önce teslim edilmişti${at === null ? '' : `: ${at}`}${
        ref === null ? '' : `, başvuru ${ref}`
      }`,
    priorUnknown: 'Geri yüklemeden önce sonucu belirsizdi',
    priorOther: (status: string) => `Geri yüklemeden önceki durum: ${status}`,
    reviewBody: (action: string, at: string, by: string, note: string | null) =>
      `${action} · ${at} · ${by}${note === null ? '' : ` — ${note}`}`,
    review: (body: string) => `Son karar: ${body}`,
  },
  /** Bilinen iş türlerinin okunur adı; listede olmayan tür kendi koduyla gösterilir */
  jobType: {
    'email.send': 'E-posta gönderimi',
    'mail.send': 'Sistem iletisi',
    'webhook.deliver': 'Web kancası teslimi',
    'automation.step': 'Otomasyon adımı',
    'automation.resume': 'Ertelenen otomasyon adımı',
    'provider.send': 'Sağlayıcı iletisi',
  } as const,
  detail: {
    job: 'İş',
    target: 'Hedef',
    status: 'Durum',
    why: 'Neden karantinada',
    prior: 'Önceki teslim kanıtı',
    lastError: 'Son deneme sonucu',
    createdAt: 'Oluşturulma',
    updatedAt: 'Son güncelleme',
    review: 'Son karar',
    key: 'İş anahtarı',
  },
  actions: {
    release: 'Serbest bırak',
    cancel: 'İptal et',
    markDelivered: 'Teslim edildi olarak işaretle',
    releaseBlocked: (why: string) => `Serbest bırakılamaz: ${why}`,
    releaseUnavailable: 'Bu iş buradan serbest bırakılamaz.',
    markDeliveredUnavailable:
      'Bu iş teslim edildi olarak işaretlenemez; otomasyon adımında yalnız iptal mümkündür.',
  },
  release: {
    title: 'İş serbest bırakılsın mı?',
    warning:
      'İş yeniden kuyruğa verilir. İlk gönderim alıcıya ulaşmışsa aynı ileti/istek ikinci kez gidebilir.',
    priorDelivered:
      'Bu iş geri yüklemeden önce teslim edilmiş görünüyor; yeniden göndermek yerine "Teslim edildi olarak işaretle" önerilir.',
    confirm:
      'Aynı iletinin ya da isteğin ikinci kez gidebileceğini biliyorum; işin yeniden kuyruğa verilmesini onaylıyorum.',
    submit: 'Serbest bırak',
    done: 'İş yeniden kuyruğa verildi',
  },
  cancelJob: {
    title: 'İş iptal edilsin mi?',
    warning: 'İş bir daha çalışmaz.',
    submit: 'İptal et',
    done: 'İş iptal edildi',
  },
  markDelivered: {
    title: 'İş teslim edildi olarak işaretlensin mi?',
    warning:
      'Dış etkinin gerçekleştiği başka kaynaktan doğrulandıysa kullanın; iş yeniden gönderilmez.',
    submit: 'Teslim edildi olarak işaretle',
    done: 'İş teslim edildi olarak işaretlendi',
  },
  reason: {
    label: 'Gerekçe',
    rule: `En az ${String(QUARANTINE_REASON_MIN)}, en çok ${String(QUARANTINE_REASON_MAX)} karakter. Karar kaydına yazılır.`,
  },
} as const;
